import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetTipoInstalacion } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveTipoInstalacion } from '../../shared/components';


export interface UpdateTipoInstalacionPageInterface {}

const returnUrlTiposInstalacion =
  ROUTER_PATHS.administration.tiposInstalacionNav;

const UpdateTipoInstalacionPage: React.FC<
  UpdateTipoInstalacionPageInterface
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_instalacion);

  const { id } = useParams();
  const { data, isLoading } = useGetTipoInstalacion(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_instalacion)
    return <Navigate to={returnUrlTiposInstalacion} />;

  return (
    <SaveTipoInstalacion
      titlePage="Editar tipo de instalación"
      editTipoInstalacion={data.data}
    />
  );
};

export default UpdateTipoInstalacionPage;
